import React, { useCallback } from 'react';
import Select, { components } from 'react-select';
import classNames from 'classnames';

import { ReactComponent as CrossGreenIcon } from '../../../assets/images/cross-outlined.svg';
import { ReactComponent as CrossIcon } from '../../../assets/images/x.svg';
import LabelWithIcon from '../Label/LabelWithIcon';

import { DropdownIndicator } from './DropdownIndicator/DropdownIndicator';
import { SelectCustomOption } from './SelectCustomOption/SelectCustomOptions';
import { colourStyles, customFilterButtonStyles, customFilterStyles } from './SelectCustomStyling';

import styles from './CustomMultiSelect.module.scss';

const CustomMultiSelect = ({
  options,
  formatOptionLabel,
  placeholder,
  isClearable,
  onChange,
  value,
  isSearchable = true,
  disabled,
  error,
  isFilterDropdown = false,
  countValue,
  isfilterByButton = false,
  setIndicator = false,
}) => {
  const filterStyling = isFilterDropdown ? customFilterStyles : colourStyles(error);
  const buttonFilterStyling = isfilterByButton ? customFilterButtonStyles : filterStyling;
  const handleRemove = useCallback(
    (toRemove) => {
      const filteredValue = value.filter((val) => val.value !== toRemove);
      onChange(filteredValue);
    },
    [value]
  );

  const customDropdownIndicator = (props) =>
    isfilterByButton || setIndicator ? <DropdownIndicator {...props} countValue={countValue} /> : null;

  return (
    <div className={classNames({ [styles.inputSelectField]: isFilterDropdown })}>
      <Select
        options={options}
        components={{
          DropdownIndicator: (props) => customDropdownIndicator(props),
          IndicatorSeparator: () => null,
          ClearIndicator: () => null,
          Option: isfilterByButton ? SelectCustomOption : components.Option,
        }}
        styles={buttonFilterStyling}
        onChange={onChange}
        isMulti
        formatOptionLabel={formatOptionLabel}
        placeholder={placeholder}
        isClearable={isClearable}
        value={value}
        isDisabled={disabled}
        controlShouldRenderValue={false}
        closeMenuOnSelect={!isfilterByButton}
        isSearchable={isSearchable}
        hideSelectedOptions={!isfilterByButton}
        menuPosition="fixed"
        portalPlacement="auto"
        menuShouldBlockScroll
        menuPortalTarget={isfilterByButton ? document.querySelector('body') : ''}
      />
      {!!value?.length && !isfilterByButton && (
        <div
          className={classNames(styles.selectedValueContainer, {
            [styles.selectedFiltersContainer]: isFilterDropdown,
          })}
        >
          {value?.map((option) => (
            <LabelWithIcon
              tag={option.label}
              customStyles={classNames(
                styles.selectedValue,
                { [styles.selectedFilter]: isFilterDropdown },
                { [styles.selectedValueText]: !isFilterDropdown }
              )}
              onDelete={() => handleRemove(option.value)}
              deleteIcon={isFilterDropdown ? <CrossIcon /> : <CrossGreenIcon />}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default CustomMultiSelect;
